<script>
import moment from 'moment-timezone'
import Services from '../../../common/Services.vue'
import Common from '../../../common/Common.vue'
import { applySessionScope, hasGlobalScope } from '../../../utils/scope'
import { clampTimelineRange, cleanTimelineRow } from '../../../utils/timeline'

export default {
    async init(state) {
        state.isLoading = false
        state.accounts = []
        state.clients = []
        state.sites = []
        state.items = []
        state.role = await Common.getSubtype(state)
        state.isSuperAdminMaster = hasGlobalScope(state)
        state.columns = [
            { label: state.$t('str.register.guard.groups.account.field'), field: 'account' },
            { label: state.$t('str.register.guard.groups.client.field'), field: 'client' },
            { label: state.$t('str.register.guard.groups.site.field'), field: 'site' },
            { label: state.$t('str.register.guard.groups.user.field') || 'Colaborador', field: 'user' },
            { label: state.$t('str.timeline.timeEntry.column.eventType'), field: 'eventType' },
            { label: state.$t('str.timeline.timeEntry.column.timestamp') || 'Timestamp', field: 'timestamp' },
        ]

        if (!state.isSuperAdminMaster) {
            state.columns.splice(0, 1)
        }

        const accountTimezone = Common.getAccountTimezone()
        const start = moment.tz(accountTimezone).startOf('day').toDate()
        const end = moment.tz(accountTimezone).endOf('day').toDate()
        const max = moment.tz(accountTimezone).endOf('day').toDate()
        state.dateRange = {
            opens: 'right',
            sampleLocaleData: {},
            range: { startDate: start, endDate: end },
            maxDate: max,
        }

        state.filters.startDate = start
        state.filters.endDate = end

        if (state.isSuperAdminMaster) {
            state.accounts = await Services.getAccounts(state)
        } else {
            state.filters.account = Common.getAccountId(state)
            state.clients = await Services.getClients(state)

            const client = Common.getClientId(state)
            if (client) {
                state.filters.client = client
                state.sites = await Services.getSites(state)
            }
        }

        if (this.methods && typeof this.methods.initTable === 'function') {
            this.methods.initTable(state)
        } else if (typeof this.initTable === 'function') {
            // fallback if initTable was defined at top-level
            this.initTable(state)
        }
    },

    methods: {
        initTable(state) {
            state.items = []
        },

        onPageChange(page) {
            const state = this
            state.currentPage = page.currentPage
            state.filters.skip = state.currentPage
            this.filter()
        },

        onPerPageChange(perPage) {
            const state = this
            state.paginationOptions.perPage = perPage.currentPerPage
            state.filters.limit = perPage.currentPerPage
            state.filters.skip = 1
            state.currentPage = 1
            this.filter()
        },

        async filter() {
            const state = this
            const accountTimezone = Common.getAccountTimezone()

            if (!applySessionScope(state, state.filters)) return

            state.isLoading = true
            const body = {
                account: state.filters.account || null,
                client: state.filters.client || null,
                site: state.filters.site || null,
                eventType: state.filters.eventType || null,
                startDate: state.filters.startDate ? moment.tz(state.filters.startDate, accountTimezone).toISOString() : null,
                endDate: state.filters.endDate ? moment.tz(state.filters.endDate, accountTimezone).toISOString() : null,
                limit: state.filters.limit || 50,
                skip: state.filters.skip || 0,
            }

            try {
                const page = await Services.getTimeEntriesPage(state, body)
                state.items = page.results.map(item => ({
                    ...item,
                    timestamp: item.createdAt,
                }))
                state.totalItems = page.totalCount
            } catch (err) {
                state.items = []
                state.totalItems = 0
                state.$notify({ type: 'error', title: state.$t('str.error'), text: err?.message || err })
            } finally {
                state.isLoading = false
            }
        },

        filterFromFirstPage() {
            this.currentPage = 1
            this.filters.skip = 1
            this.filter()
        },

        changeAccount() {
            const state = this
            state.clients = []
            state.sites = []
            if (!state.filters.account) return
            Services.getClientsByAccount(state, state.filters.account).then((clients) => {
                state.clients = clients || []
            })
        },

        changeClient() {
            const state = this
            state.sites = []
            if (!state.filters.client) return
            Services.getSitesByClient(state, state.filters.client).then((sites) => {
                state.sites = sites || []
            })
        },

        changeSite() {
            // placeholder: if additional site-based loading required
        },

        updateValues(range) {
            const state = this
            const accountTimezone = Common.getAccountTimezone()
            const { startDate, endDate, wasClamped } = clampTimelineRange(range.startDate, range.endDate, accountTimezone)

            if (wasClamped) Common.show(state, 'top-right', 'warn', state.$t('str.charts.date.range.max'))

            state.dateRange.range.startDate = startDate
            state.dateRange.range.endDate = endDate
            state.filters.startDate = startDate
            state.filters.endDate = endDate
        },

        selectItem(params) {
            this.selectedItem = cleanTimelineRow(params.row)
            this.$bvModal.show('timeEntryDetailModal')
        },

        formatDate(value) {
            if (!value) return ''
            return Common.formatDateAndTime ? Common.formatDateAndTime(value) : ''
        },
    },
}
</script>
